module.exports = __webpack_public_path__ + "img/edge_settings.efbd174f.png";